<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2 scrollTableNoTab">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @change-selected="changeSelectedTable"
                            @get-column-settings="getColumnSettings"
                            ref="gofixTable">
                            <template slot="gofix_table:after-control-left">
                                <gofix-button class="ml-2" label="Proceed" outline @click="proceedApproval"></gofix-button>
                            </template>
                            <template slot="gofix_table:actions" slot-scope="data" v-if="data.item.status === 'Posted'">
                                <b-form-checkbox disabled></b-form-checkbox>
                            </template>
                            <template slot="gofix_table:created_at" slot-scope="row">
                                {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:doc_date" slot-scope="row">
                                {{row.item.doc_date  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:amount" slot-scope="row">
                                {{ row.item.amount | formatMoney }}
                            </template>
                            <template slot="gofix_table:tax" slot-scope="row">
                                {{ row.item.tax | formatMoney }}
                            </template>
                            <template slot="gofix_table:total" slot-scope="row">
                                {{ row.item.total | formatMoney }}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
        <ApprovalMultiple 
            title="Approval For Multiple Credit Note" 
            :credits="proceed.ids" v-model="proceed.open"
            @approval-success="$refs.gofixTable.reloadTableKeepFilter()" />
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js';
    const ApprovalMultiple = () => import('@/views/dashboard-approval/approval-multiple')

    export default {
        name: 'payment-voucher',
        components: {
            ApprovalMultiple
        },
        data () {
            let filter =  JSON.parse(JSON.stringify(filters['credit_note_approval']));
            return {
                tableConfig:{
                    name: 'credit-note-listing',
                    controls:{
                        create: false,
                        delete: false,
                        tableImport: false,
                        tableExport: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    isCMS: true,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                    dataSelect: {
                        status: {
                            value: [
                                {value: 'Draft', text: 'Draft'},
                                {value: 'Under Approval', text: 'Under Approval'},
                                {value: 'Approved', text: 'Approved'},
                                {value: 'Rejected', text: 'Rejected'},
                            ],
                            value_field: 'value',
                            text_field: 'text'
                        }
                    }
                },
                tableItems: [],
                proceed: {
                    open: false,
                    ids:  []
                }
            }
        },
        watch: {
            // platform: function(val) {
            //     this.$refs.gofixTable.reloadTableKeepFilter();
            // }
        },
        created(){
        },
        methods:{
            getColumnSettings(settings){
                // if(settings.length && this.$refs.gofixTable) {
                //     let field = settings.map(item => {
                //         if(item.key == "status") {
                //             item.isFilter = false;
                //             item.filter.active = false;
                //         }
                //         return item;
                //     });
                //     this.$refs.gofixTable.updateColumnSettings(field);
                // }
            },
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.type_check = 'credit_note_lm';
                await this.$store.dispatch("AwaitingApprovalController/getAwaitingApproval", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async clickToRowItem(item){
                return this.$router.push(`/approvals/credit-note/${item.id}`)
            },
            changeSelectedTable(ids) {
                this.proceed.ids = ids;
            },
            proceedApproval() {
                if(!this.proceed.ids.length)
                    return this.$alertNotification('Please select at least one item before proceed', 'danger');
                this.proceed.open = true;
            }
        }
    }
</script>
